<template lang="pug">
    section#novosTempos
        div.wrapper
            h2
                |NOVOS TEMPOS PEDEM MAIS SOLUÇÕES
            p
                |Há mais de 20 anos atuando na educação a distância, sabemos dos desafios de capacitar docentes para o
                |exercício do ensino na internet. Fazemos isso constantemente em nosso Centro de Excelência em Formação
                |de Docentes em EAD, utilizando dos métodos mais tradicionais aos recursos mais avançados com uso de realidade virtual.
            p
                |Por isso, reconhecemos a imensa adaptação que se requer dos milhares de docentes de todo o país para
                |continuarem a desempenhar suas funções em tempos de Covid-19. Vendo a atual situação destes professores
                |que tiveram que se adaptar da noite para o dia, transformando seu método de ensino dos quadros para as
                |telas de computadores, a UniFAEL quis colaborar com a qualidade desta transformação, e disponibilizou
                |gratuitamente o recém lançado curso Educação a Distância 4.0.
            p
                |Juntos, vamos manter um ensino de qualidade para mudar a educação no Brasil.
            span
                |Processo 100% Online
</template>

<script>
export default {
    name: "section-novos-tempos"
}
</script>

<style lang="stylus" scoped src="./NovosTempos.styl"></style>
